import "bootstrap/dist/css/bootstrap.min.css";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import VueZoomer from 'vue-zoomer'


import {LoadingPlugin} from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

import SplitCarousel from "vue-split-carousel";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import VueToast from 'vue-toast-notification';
import store from "./store/storeModules.js";

import PriceFormatter from "./plugins/PriceFormatter.js"
import CurrencyConverter, { fetchRates, scheduleCurrencyRateRefresh } from "./plugins/CurrencyConverter.js"
import DateFormatter from "./plugins/DateFormatter.js"
import FileSource from "./plugins/FileSource.js"
import Slugerize from "./plugins/Slugerize.js"
import i18n, { languageMap } from "./i18n/index.js"

import "./icons/iconsSolid.js";
import "./icons/iconsRegular.js";
import "./icons/iconsBrands.js";


// Import one of the available themes
//import 'vue-toast-notification/dist/theme-default.css';
import 'vue-toast-notification/dist/theme-sugar.css';


const Vue = createApp(App);

router.beforeEach(() => {
  window.scrollTo(0, 0)
  store.commit("forceCloseModal")
})
Vue.use(VueZoomer)
  .use(router)
  .use(store)
  .use(i18n)
  .use(PriceFormatter)
  .use(CurrencyConverter)
  .use(FileSource)
  .use(VueToast)
  .use(Slugerize)
  .use(DateFormatter)
  .use(SplitCarousel)
  .use(LoadingPlugin)
  .component("font-awesome-icon", FontAwesomeIcon)

  // Initialize i18n locale from persisted store state
  const persistedLanguage = store.state.app.language;
  if (persistedLanguage && languageMap[persistedLanguage]) {
    i18n.global.locale.value = languageMap[persistedLanguage];
  }
  
  // Preload currency rates before mounting the app
  fetchRates()
    .then(() =>{
      console.log('Currency rates preloaded successfully on APP mount.')
    })
    .catch(err => {
      console.warn('Failed to preload currency rates:', err);
    })
    .finally(() => {
      scheduleCurrencyRateRefresh();
      Vue.mount("#app");
    });
    // .mount("#app");


  export default Vue